import { useState } from 'react';
import styles from './QRCode.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';
import Dropdown from '../../components/Dropdown/Dropdown';
import QRImage from './../../assets/images/qrImage.png';
import HeadingAndData from '../../components/HeadingAndData/HeadingAndData';

const QRCode = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    formType: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    if (!formData.formType) {
      alert('Please select a form.');
      return;
    }
    console.log('Form submitted:', formData);
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setFormData({ formType: '' });
    dispatch(closeModal());
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon heading="QR Code " />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.body}>
        <p className={styles.instructions}>
          <strong>Instructions:</strong>
          <br />
          Please take print and stick on ID card. Teachers can use this to
          quickly scan and do check in.
        </p>

        <div className={styles.qrData}>
          <div className={styles.BottomSection}>
            <img src={QRImage} alt="QR Image" />
          </div>
        </div>

        <SaveAndCancel
          cancelLabel="Cancel"
          saveLabel="Save"
          onCancel={handleCancel}
          onSave={handleSave}
        />
      </div>
    </div>
  );
};

export default QRCode;
